(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications-skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications-skeleton.js');
'use strict';

const {
  useState
} = React;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  titles,
  icons
} = svs.myProfile.constants;
const NotificationsSkeleton = () => {
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(TopHeader, {
    icon: icons.CORRECT,
    title: titles.CORRECT
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 4,
    boxWidthProcent: 100,
    topMargin: 2
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 80,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 80,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 100,
    topMargin: 1
  }), isPlayerLoggedIn && React.createElement(React.Fragment, null, React.createElement(TopHeader, {
    icon: icons.PLAYTOGETHER,
    title: titles.PLAYTOGETHER
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 4,
    boxWidthProcent: 100,
    topMargin: 2
  }), React.createElement(TopHeader, {
    icon: icons.FRACTIONGAME,
    title: titles.FRACTIONGAME
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 4,
    boxWidthProcent: 100,
    topMargin: 2
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 2,
    boxWidthProcent: 100,
    topMargin: 1
  })));
};
svs.myProfile.react.pages.notifications.NotificationsSkeleton = NotificationsSkeleton;

 })(window);